import { AllInclusiveContent, TravelerReviewContent } from "typings/microserviceModels/hotels-flex-module";
import * as React from "react";
import { HotelAllInclusiveBadge } from "./HotelAllInclusiveBadge";
import { GreatForAffinityBadge } from "./GreatForAffinityBadge";

export interface HotelBadgeProps {
  allInclusiveContent?: AllInclusiveContent;
  travelerReviewContent?: TravelerReviewContent;
}

export const HotelBadge = (props: HotelBadgeProps) => {
  const { allInclusiveContent, travelerReviewContent } = props;

  if (allInclusiveContent) {
    return <HotelAllInclusiveBadge {...allInclusiveContent} />;
  }

  if (travelerReviewContent) {
    return <GreatForAffinityBadge travelerReviewContent={travelerReviewContent} />;
  }

  return null;
};
